import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import '../css/termsAndConditions.scss';
import parse from 'html-react-parser';
import HomePageLogo from '../../../../../assets/images/vms/bslogo.png';

/**
 * Show a list of validation errors for given field
 * @param {Array} errors
 * @param {string} fieldName
 * @returns string | null
 */
const renderError = (errors, fieldName) => {
  const messages = errors[fieldName];
  return _.has(errors, fieldName)
    ? _.map(messages, message => {
        return (
          <li className="ci-error" key={message}>
            {message}
          </li>
        );
      })
    : null;
};

const Page2 = props => {
  const { setFieldValue, agree, errors, translations, setGoTo, config, matches } = props;
  const tcTitle = _.get(translations, 't&c-title');
  const tcBody = _.get(translations, 't&c-body');

  return (
    <>
      <div className="tc-wrap">
        <div className="tc-wrap__head">
          <div className="tc-wrap__head-logo">
            <img src={HomePageLogo} alt="homepage-logo" />
          </div>
        </div>
        <div className="tc-wrap__form">
          <div className="tc-wrap__head-title">{tcTitle}</div>
          <div className="tc-form">
            <div className="tc-form__terms">
              <div className="tc-form__terms-description">{parse(tcBody)}</div>
            </div>
            <div className="tc-form__agreement">
              <input
                name="agree"
                type="checkbox"
                className="tc-form__agreement-checkbox"
                onChange={() => setFieldValue({ agree: !agree, matches })}
                checked={agree}
              />
              <div className="tc-form__agreement-text">{_.get(translations, 'agreementText')}</div>
              <ul>{renderError(errors, 'agree')}</ul>
            </div>
            <div className="tc-form__buttons">
              <button type="button" className="tc-form__buttons-previous" onClick={() => setGoTo('previous')}>
                {_.get(config, 'page2.btn_prev.text', '')}
              </button>
              <button type="button" className="tc-form__buttons-accept" disabled={!agree} onClick={() => setGoTo('next')}>
                {_.get(config, 'page2.btn_next.text', '')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="ci-footer">{_.get(translations, 'allRightsReserved')}</div>
    </>
  );
};

Page2.propTypes = {
  translations: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.any,
  agree: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  setGoTo: PropTypes.func.isRequired,
  config: PropTypes.shape(),
  matches: PropTypes.arrayOf(PropTypes.shape),
};

Page2.defaultProps = {
  translations: {},
  errors: [],
  agree: false,
  config: {},
  matches: [],
};

export default Page2;
